import React from 'react';
import MainGame from './pages/main_page';
import SplashPage from './pages/splash_page';
import {useEffect, useState} from 'react'; 
import bg3 from './assets/bg3.jpg';
import bajaj2 from './assets/bajaj2.png';
import bajajLogo from './assets/bajaj_logo.png';
import cloud from './assets/cloud.png';
import cloud2 from './assets/cloud2.png';
import mountain from './assets/mountain.PNG';
import tree3 from './assets/tree3.PNG';
import wall1 from './assets/wall1.png';
import wall2 from './assets/wall2.png';
import building from './assets/building.png';
import building2 from './assets/building2.png';
import bgMusic from './assets/audio/bg_music.wav';
import bajaj from './assets/audio/bajaj.wav';
import win from './assets/audio/win.wav';


function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const preloadAssets = async () => {

      const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;


      const imageUrls = [
        bg3,
        bajaj2,
        bajajLogo,
        cloud,
        cloud2,
        
        tree3,
        wall1,
        wall2,
        building,
        
      ];
      const audioUrls = [
        bgMusic,
        bajaj,
        win
      ];
  
      const imagePromises = imageUrls.map(
        (src) =>
          new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            img.onload = resolve;
            img.onerror = (err) => reject(new Error(`Failed to load image: ${src}`));
          })
      );
  
      const audioPromises = audioUrls.map(
        (src) =>
          new Promise((resolve, reject) => {
            const audio = new Audio();
            audio.src = src;

            if (isIOS) {
              audio.load();
              resolve();
              return;
            }
            
            audio.oncanplaythrough = resolve;
            audio.onerror = (err) => reject(new Error(`Failed to load audio: ${src}`));
          })
      );
      console.log("Image promises", imagePromises);
      console.log("Audio promises", audioPromises);
      await Promise.all([...imagePromises, ...audioPromises]);
      console.log("Assets loaded");
      setIsLoaded(true);
    };
  
    preloadAssets();
  }, []);
  return (
    <>
      {!isLoaded ? <SplashPage /> : <MainGame />}
    </>
   
  );
}

export default App;
